import APIClient from './index';
import _ from 'lodash';

export const getRecentMessages = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Admin/get_recent_messages`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

/**
 * @param {('user'|'brand'|'lookbookorders'|'brandwaitlist')} accountType
 * @param {Object} [options]
 * @param {boolean} [options.withSlackChannel] - only include admins with a personal slack channel configured
 */
export const getAccountManagers = (accountType, options = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Admin/account_managers?account_type=${accountType}${options.withSlackChannel ? '&with_slack_channel=true' : ''}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getSlackUserIds = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`Admin/get_slack_user_ids`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
